import React from "react";
import { Alert } from "reactstrap";

import { StateError } from "@orm/models";

interface ErrorAlertProps {
    error: StateError;
}

export const ErrorAlert = ({ error }: ErrorAlertProps) => (
    <Alert color="danger">
        <span>{error.message}</span>
        {error.errors != null &&
            <div>
                <hr />
                <ul className="mb-0">
                    {error.errors.map((e) => <li key={e.key}>{e.message}</li>)}
                </ul>
            </div>
        }
    </Alert>
);
